import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Grid } from '@mui/material';
import Alert from '@mui/material/Alert';

export default function TableSkeleton() {
  return (
    <Grid container p={4} spacing={2}>
      <Grid item xs={12}>
        <Alert severity="info">Espere un momento por favor, esto puede tardar unos minutos.</Alert>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rounded" height={120}></Skeleton>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" ></Skeleton>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" ></Skeleton>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" ></Skeleton>
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="rectangular" ></Skeleton>
      </Grid>
    </Grid>
  );
}